export { illustrationSizes, IllustrationSize } from './illustration';
